//Code Migrate from Copy of Clutch To Clutch
class QuantityInput extends HTMLElement {
  constructor() {
    super();

    this._boundAdd = this.add.bind(this);
    this._boundSubtract = this.subtract.bind(this);
    this._boundValidate = this.validate.bind(this);
    this._boundSelect = this._selectInputText.bind(this);
  }

  connectedCallback() {
    this.input = this.querySelector('input[type="number"]');

    this.minus = this.querySelector('button[minus]');
    this.plus = this.querySelector('button[plus]');

    this.min = Number(this.input.getAttribute('min') || 0);
    this.max = Number(this.input.getAttribute('max') || Infinity);
    this.step = Number(this.input.getAttribute('step') || 1);

    /* ITG TS - set initial button disabled states */
    this._updateButtons();

    setTimeout(() => {
      this.minus.addEventListener('click', this._boundSubtract);
      this.plus.addEventListener('click', this._boundAdd);
      this.input.addEventListener('change', this._boundValidate);
      this.input.addEventListener('select', this._boundSelect);
      this.input.addEventListener('click', this._boundSelect);
    });
  }

  disconnectedCallback() {
    this.minus.removeEventListener('click', this._boundSubtract);
    this.plus.removeEventListener('click', this._boundAdd);
    this.input.removeEventListener('change', this._boundValidate);
    this.input.removeEventListener('select', this._boundSelect);
    this.input.removeEventListener('click', this._boundSelect);
  }

  subtract() {
    const value = Number(this.input.value);
    if (value > this.min) {
      /* ITG TS - old code start */
      // this.input.value = value - Math.min(this.step, value - this.min);
      /* ITG TS - old code end */
      /* ITG TS - round to 1dp to avoid floating point drift */
      this.input.value = parseFloat((value - Math.min(this.step, value - this.min)).toFixed(1));
      // this.input.dispatchEvent(new Event('change'));
      this.dispatchEvent(
        new CustomEvent('update', {
          detail: {
            value: this.input.value,
          },
        }),
      );
    }
    /* ITG TS - update button states after subtract */
    this._updateButtons();
  }

  add() {
    const value = Number(this.input.value);
    if (value < this.max) {
      /* ITG TS - old code start */
      // this.input.value = value + Math.min(this.step, this.max - value);
      /* ITG TS - old code end */
      /* ITG TS - round to 1dp to avoid floating point drift */
      this.input.value = parseFloat((value + Math.min(this.step, this.max - value)).toFixed(1));
      // this.input.dispatchEvent(new Event('change'));
      this.dispatchEvent(
        new CustomEvent('update', {
          detail: {
            value: this.input.value,
          },
        }),
      );
    }
    /* ITG TS - update button states after add */
    this._updateButtons();
  }

  validate(e) {
    const value = e.target.value;
    /* ITG TS - old code start */
    // const testRegEx = /^[0-9]+$/;
    /* ITG TS - old code end */
    /* ITG TS - allow decimals for fabric qty */
    const testRegEx = /^[0-9]+(\.[0-9]+)?$/;

    if (!testRegEx.test(value) || Number(value) < this.min) {
      this.input.value = this.min;
    }

    if (Number(value) > this.max) {
      this.input.value = this.max;
    }

    this.dispatchEvent(
      new CustomEvent('update', {
        detail: {
          value: this.input.value,
        },
      }),
    );

    /* ITG TS - update button states after validate */
    this._updateButtons();
  }

  /* ITG TS - disable minus/plus buttons at min/max */
  _updateButtons() {
    const value = Number(this.input.value);
    if (this.minus) this.minus.disabled = value <= this.min;
    if (this.plus) this.plus.disabled = value >= this.max;
  }

  _selectInputText(e) {
    e.target.select();
  }

  set value(value) {
    this.input.value = Number(value);
    /* ITG TS - update button states when value is set programmatically */
    this._updateButtons();
  }

  get value() {
    return Number(this.input.value);
  }
}
customElements.define('quantity-input', QuantityInput);





/*class QuantityInput extends HTMLElement {
  constructor() {
    super();

    this._boundAdd = this.add.bind(this);
    this._boundSubtract = this.subtract.bind(this);
    this._boundValidate = this.validate.bind(this);
    this._boundSelect = this._selectInputText.bind(this);
  }

  connectedCallback() {
    this.input = this.querySelector('input[type="number"]');

    this.minus = this.querySelector('button[minus]');
    this.plus = this.querySelector('button[plus]');

    this.min = Number(this.input.getAttribute('min') || 0);
    this.max = Number(this.input.getAttribute('max') || Infinity);
    this.step = Number(this.input.getAttribute('step') || 1);

    setTimeout(() => {
      this.minus.addEventListener('click', this._boundSubtract);
      this.plus.addEventListener('click', this._boundAdd);
      this.input.addEventListener('change', this._boundValidate);
      this.input.addEventListener('select', this._boundSelect);
      this.input.addEventListener('click', this._boundSelect);
    });
  }

  disconnectedCallback() {
    this.minus.removeEventListener('click', this._boundSubtract);
    this.plus.removeEventListener('click', this._boundAdd);
    this.input.removeEventListener('change', this._boundValidate);
    this.input.removeEventListener('select', this._boundSelect);
    this.input.removeEventListener('click', this._boundSelect);
  }

  subtract() {
    const value = Number(this.input.value);
    if (value > this.min) {
      this.input.value = value - Math.min(this.step, value - this.min);
      // this.input.dispatchEvent(new Event('change'));
      this.dispatchEvent(
        new CustomEvent('update', {
          detail: {
            value: this.input.value,
          },
        }),
      );
    }
  }

  add() {
    const value = Number(this.input.value);
    if (value < this.max) {
      this.input.value = value + Math.min(this.step, this.max - value);
      // this.input.dispatchEvent(new Event('change'));
      this.dispatchEvent(
        new CustomEvent('update', {
          detail: {
            value: this.input.value,
          },
        }),
      );
    }
  }

  validate(e) {
    const value = e.target.value;
    const testRegEx = /^[0-9]+$/;

    if (!testRegEx.test(value) || Number(value) < this.min) {
      this.input.value = this.min;
    }

    if (Number(value) > this.max) {
      this.input.value = this.max;
    }

    this.dispatchEvent(
      new CustomEvent('update', {
        detail: {
          value: this.input.value,
        },
      }),
    );
  }

  _selectInputText(e) {
    e.target.select();
  }

  set value(value) {
    this.input.value = Number(value);
  }

  get value() {
    return Number(this.input.value);
  }
}
customElements.define('quantity-input', QuantityInput);
*/